import type { Services } from '../../store/slices/timesheet/timesheetPageSlice';
import type {
  KmsVehicle,
  ServiceExecutionUpdateRequest,
} from '../../store/slices/timesheet/timesheetApprovalDetails/timesheetApprovalDetailsSlice';

// Helper to check valid KMS rows
const isValidKms = (k: KmsVehicle) => {
    const ini = k.kmsIni ?? 0
    const end = k.kmsEnd ?? 0
    return !(ini === 0 && end === 0)
}

export function mapServicesForApproval(
  pageServices: Services[],
): ServiceExecutionUpdateRequest[] {
  const finalCopy: ServiceExecutionUpdateRequest[] = [];
  for (let i = 0; i < pageServices.length; i++) {
    const serviceInstance = pageServices[i];
    const { service, serviceExecution } = serviceInstance;

    const filteredKmsVehicles = serviceExecution?.kmsVehicles?.filter(isValidKms);

    finalCopy[i] = {
      serviceId: service.serviceId,
      pax: serviceExecution?.pax ?? service.pax,
      isClean: serviceExecution?.isClean ?? service.isClean,
      startDateTime: serviceExecution?.startDateTime ?? service.startDateTime,
      endDateTime: serviceExecution?.endDateTime ?? service.endDateTime,
      isAU: service?.isAU ?? false,
      kmsVehicles: filteredKmsVehicles?.map((kv) => ({
        kmsId: kv.kmsId,
        kmsIni: kv.kmsIni,
        kmsEnd: kv.kmsEnd,
        inEmpty: kv.inEmpty,
      })) as KmsVehicle[],
    };
  }
  return [...finalCopy];
}

export function mapServicesForEdit(
  acceptedServices: ServiceExecutionUpdateRequest[],
): ServiceExecutionUpdateRequest[] {
  const finalCopy: ServiceExecutionUpdateRequest[] = [];
  for (let i = 0; i < acceptedServices?.length; i++) {
    const service = acceptedServices[i];

    const filteredKmsVehicles = service.kmsVehicles?.filter(isValidKms);

    finalCopy[i] = {
      ...service,
      kmsVehicles: filteredKmsVehicles?.map((kv) => ({
        kmsId: kv.kmsId,
        kmsIni: kv.kmsIni,
        kmsEnd: kv.kmsEnd,
        inEmpty: kv.inEmpty,
      })) as KmsVehicle[],
    };
  }
  return [...finalCopy];
}
